import React from 'react'
import translate from '../../reusable/translate'

const Tooltip = ({ textKey, secondaryTextKey, fallback, languageOverride }) => {

    return(
        <div className="tooltip-container">
            <i className="fas fa-info-circle"/>
            <div className="tooltip-content">
                <div dangerouslySetInnerHTML={
                    { __html : translate({ textKey: textKey, secondaryTextKey: secondaryTextKey, fallback: fallback, languageOverride: languageOverride }) }
                }
                />
            </div>
        </div>
    )
}

export default Tooltip


// WEBPACK FOOTER //
// ./src/components/materialCommitment/tooltip/Tooltip.jsx